import { BrowserEvents } from './constants';

;(function($) {

	$(document).on(BrowserEvents.barba.enter, function() {

		// ---------- Carousels ----------

		$('.content-section .masonry').each(function() {
			const self = $(this);

			self.isotope({
				masonry: {
					percentPosition: true
				},
				itemSelector: ".single-column"
			})
		});

		$('.content-section .carousel').each(function() {

			const self = $(this);

			const settings = {
				arrows: false,
				infinite: false,
				centerMode: false,
				slidesToShow: 4,
				slidesToScroll: 4,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			};

			self.on('init reInit beforeChange afterChange', function() {
				$(window).trigger(lazyLoadRefreshEvent);
			});

			if(!self.hasClass('slick-initialized')) {
				self.slick(settings);
			}
		});

		$('.content-section .slideshow').each(function() {

			const self = $(this);

			const settings = {
				infinite: true,
				autoplaySpeed: 3000,
				arrows: false,
				autoplay: true,
				speed: 2000,
				fade: true,
			};

			self.on('init reInit beforeChange afterChange', function() {
				$(window).trigger(BrowserEvents.lazyload);
			});

			if(!self.hasClass('slick-initialized')) {
				self.slick(settings);
			}
		});

		$('.gallery').each(function() {
			const self = $(this);

			self.lightGallery({
				download: false,
			});
		});

		// ---------- Vide ----------

		$('.content-section .video-background').each(function() {
			const self = $(this);
			const video = self.data('video');
			const poster = self.data('poster');

			self.vide({
				mp4: video,
				poster: poster
			}, {
				posterType: 'jpg'
			});
		});

	});

}(jQuery));
